/**
 * Membership UI Web App
 * @flow weak
 */

// $FlowIssue
import React, { Suspense } from 'react';
import { hot } from 'react-hot-loader';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import { AppProvider } from '~/features/App/AppProvider';
import { Auth } from '~/features/App/Auth';
import { DataProvider } from '~/features/App/DataProvider';
import { ErrorBoundaryReporter } from '~/features/App/ErrorBoundaryReporter';
import { Layout } from '~/features/App/Layout';
import { Notifications } from '~/features/App/Notifications';

import { InformationRoot } from '~/features/Information/InformationRoot/AsyncInformationRoot';
import { MyWealthRoot } from '~/features/MyWealth/MyWealthRoot/AsyncMyWealthRoot';
import { ArchivedTransactionsRoot } from '~/features/ArchivedTransactions/ArchivedTransactionsRoot/AsyncArchivedTransactionsRoot';
import { Network } from '~/features/Network/AsyncNetwork';
import { Profile } from '~/features/Profile/AsyncProfile';

import { Gag } from '~/components/Gag';
import { Loader } from '~/components/Loader';

/**
 * App React-component
 * @returns {React.Node<*>} React-component
 */
const App = () => (
  <ErrorBoundaryReporter>
    <DataProvider>
      <AppProvider>
        <BrowserRouter>
          <Auth>
            <Layout>
              <Suspense
                fallback={<Gag icon={<Loader />} palette="grayscale" />}
              >
                <Switch>
                  <Route path="/information" component={InformationRoot} />
                  <Route path="/wealth" component={MyWealthRoot} />
                  <Route
                    path="/archived-transactions"
                    component={ArchivedTransactionsRoot}
                  />
                  <Route
                    exact
                    path="/network/:referralName?/:generationLevel?/:filter?"
                    component={Network}
                  />
                  <Route exact path="/profile" component={Profile} />
                  <Redirect to="/wealth" />
                </Switch>
              </Suspense>
            </Layout>
            <Notifications />
          </Auth>
        </BrowserRouter>
      </AppProvider>
    </DataProvider>
  </ErrorBoundaryReporter>
);

export default hot(module)(App);
